import React, { useState } from "react";
import styles from "./SupplierBalances.module.css";

const SupplierBalances = ({ balances }) => {
  const [expanded, setExpanded] = useState(false);

  if (!balances.length) return null;

  const totalRemaining = balances.reduce((sum, b) => sum + (b.totalRemaining || 0), 0);
  const visibleBalances = expanded ? balances : balances.slice(0, 4);

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerRow}>
        <h4 className={styles.title}>أرصدة الموردين</h4>
        <span className={styles.totalRemaining}>
          إجمالي المتبقي: {totalRemaining.toLocaleString("ar-EG")} ج.م
        </span>
      </div>

      <div className={styles.grid}>
        {visibleBalances.map((b) => (
          <div key={b.supplierName} className={styles.card}>
            <span className={styles.supplierName}>{b.supplierName}</span>
            <div className={styles.row}>
              <span>الكمية</span>
              <span>{b.totalQuantity}</span>
            </div>
            <div className={styles.row}>
              <span>الإجمالي</span>
              <span>{b.totalAmount.toLocaleString("ar-EG")} ج.م</span>
            </div>
            <div className={styles.row}>
              <span>المدفوع</span>
              <span className={styles.paid}>{b.totalPaid.toLocaleString("ar-EG")} ج.م</span>
            </div>
            <div className={styles.row}>
              <span>المتبقي</span>
              <span className={styles.remaining}>{b.totalRemaining.toLocaleString("ar-EG")} ج.م</span>
            </div>
          </div>
        ))}
      </div>

      {balances.length > 4 && (
        <button className={styles.toggleBtn} onClick={() => setExpanded((prev) => !prev)}>
          {expanded ? "عرض أقل" : `عرض الكل (${balances.length})`}
        </button>
      )}
    </div>
  );
};

export default SupplierBalances;